export default "__VITE_ASSET__de1acb91__"